import { useDownloadingFile } from 'src/hooks/ui'

type DeviceType = 'sensor' | 'dataLogger' | 'wagnerProbe'

interface DownloadParams {
  dateFrom?: string
  dateTo?: string
  unit: 'F' | 'C'
}

const urlPathByDeviceType: Record<DeviceType, (id: string) => string> = {
  sensor: (id) => `v1/admin/sensors/${id}/measurements`,
  dataLogger: (id) => `v1/admin/data-loggers/${id}/measurements`,
  wagnerProbe: (id) => `v1/admin/wagner-probes/${id}/measurements`,
}

export const useDownloadMeasurements = (deviceType: DeviceType, deviceId: string) => {
  const { downloadFile, isLoading } = useDownloadingFile()

  const download = (params: DownloadParams) =>
    downloadFile({
      urlPath: urlPathByDeviceType[deviceType](deviceId),
      queryParams: { ...params },
      noDataMessage: 'No measurements found for the selected period',
    })

  return { download, isLoading }
}
